export const RECEIVE_CHANNELS = 'RECEIVE_CHANNELS'
export const RECEIVE_CHANNEL = 'RECEIVE_CHANNEL'
export const RECEIVE_CHANNELS_ERROR = 'RECEIVE_CHANNELS_ERROR'
export const RECEIVE_CHANNEL_ERROR = 'RECEIVE_CHANNEL_ERROR'
export const CLEAR_CHANNELS = 'CLEAR_CHANNELS'
export const RECEIVE_RELATED_CHANNEL_CONTENT = 'RECEIVE_RELATED_CHANNEL_CONTENT'
export const DELETE_RELATED_CHANNEL_CONTENT = 'DELETE_RELATED_CHANNEL_CONTENT'
